(function () {
  function clampIndex(index, total) {
    if (total < 1) return 0;
    if (index < 0) return total - 1;
    if (index >= total) return 0;
    return index;
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.slGalleryReady === 'true') return;
    gallery.dataset.slGalleryReady = 'true';

    var track = gallery.querySelector('[data-sl-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-sl-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-sl-gallery-thumb]'));
    var prev = gallery.querySelector('[data-sl-gallery-prev]');
    var next = gallery.querySelector('[data-sl-gallery-next]');
    if (!track || slides.length < 1) return;

    var activeIndex = Math.max(0, slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    }));
    var startX = 0;
    var deltaX = 0;

    function update(index) {
      activeIndex = clampIndex(index, slides.length);
      track.style.transform = 'translate3d(' + (-activeIndex * 100) + '%, 0, 0)';

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        update(parseInt(thumb.dataset.galleryIndex || '0', 10));
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        update(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        update(activeIndex + 1);
      });
    }

    track.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      deltaX = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      deltaX = event.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (Math.abs(deltaX) > 42) {
        update(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
      }
      startX = 0;
      deltaX = 0;
    });

    update(activeIndex);
  }

  function initAllGalleries() {
    document.querySelectorAll('[data-sl-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  document.addEventListener('shopify:section:load', initAllGalleries);
})();
